export default __webpack_public_path__ + "static/media/hospital.b69ba916.svg";